import { actionType } from "../utils/helpers/generalHelper";
import * as MetricsConstants from "../constants/metrics.constant";
import MetricsService from "../services/metrics.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import { toast } from "react-hot-toast";

export const getMetrics = () => async (dispatch) => {
  try {
    dispatch(actionType(MetricsConstants.FETCH_METRICS_REQUEST));
    const data = await MetricsService.getSystemMetrics();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(actionType(MetricsConstants.FETCH_METRICS_SUCCESS, responseData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(MetricsConstants.FETCH_METRICS_FAILURE));
    toast.error(message);
  }
};

export const getTransactionMetrics = () => async (dispatch) => {
  try {
    dispatch(actionType(MetricsConstants.FETCH_TRANSACTION_METRICS_REQUEST));
    const data = await MetricsService.getTransactionMetrics();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(
        MetricsConstants.FETCH_TRANSACTION_METRICS_SUCCESS,
        responseData
      )
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(MetricsConstants.FETCH_TRANSACTION_METRICS_FAILURE));
    toast.error(message);
  }
};
